module.exports = __webpack_public_path__ + "img/Sahrawi Arab Democratic Republic.d67037bd.svg";